/**
 * De qué página de faktelio.com viene quien se da de alta — `global/0021`.
 *
 * El sitio público pone `?origen=<pagina>:<boton>` en cada enlace a la
 * aplicación (`apps/site/src/content/origen.ts`). Aquí se lee UNA vez, al
 * cargar y antes de limpiar la barra, y viaja con el alta para que la API sume
 * uno a esa página.
 *
 * ## Lo que esto NO es
 *
 * **No se guarda en el navegador.** Ni cookie ni `localStorage`: si la persona
 * recarga o vuelve otro día, el alta cuenta como `sin-origen`, y es lo correcto.
 * Recordarlo sería seguir a alguien entre visitas, y eso ya pide consentimiento.
 *
 * **No concede nada.** Es una estadística: la API la acota otra vez
 * (`origenDeAlta`) y nunca rechaza un alta por ella.
 */

/** El parámetro que pone el sitio público. */
export const PARAMETRO = "origen";

/** La misma forma que acepta la API: minúsculas, cifras, `-` y `:`, hasta 80. */
const FORMA = /^[a-z0-9][a-z0-9:-]{0,79}$/;

/** El origen que trae la URL, o `null`. */
export function origenDelEnlace(search: string): string | null {
  const valor = new URLSearchParams(search).get(PARAMETRO);
  return valor !== null && FORMA.test(valor) ? valor : null;
}
